module.exports = __webpack_public_path__ + "static/media/movieDb.b6759a00.png";